// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"4cfef092","501":"c0573be5","544":"a97786b6","626":"d306b79d","947":"febef2e5"}[chunkId] + ".chunk.js";
};